import React, { Component } from "react";
import firebase from "../../utils/firebase";
import { Helmet } from "react-helmet";

import {
  GetParam,
  GetUser,
  GetApplication,
  RequiredProfile
} from "../../utils/consts";
import Loading from "../../components/loading/Loading";

import Panel from "@atlaskit/panel";

import "./application.css";
import { UserContext } from "../../Context";
import LoggedOutContent from "../../components/LoggedOutContent/LoggedOutContent";
import ProfilePreviewCard from "../../components/ProfilePreviewCard/ProfilePreviewCard";
export default class Application extends Component {
  state = { loading: true };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const uid = GetParam("uid", this.props);
      const user = await GetUser(uid);
      const application = await GetApplication(uid);
      this.setState({
        application: application || {},
        user: user || {},
        uid: uid || "",
        loading: false
      });
    } catch (error) {
      this.setState({ application: {}, user: {}, uid: "", loading: false });
      this.props.addFlag({
        appearance: 2,
        title: "Error - Please Retry"
      });
    }
  };

  getAgreement = async () => {
    try {
      this.setState({ agreementLoading: true });
      const application = this.state.application || {};
      const docid = application.docid || "";
      const getAgreement = firebase.functions().httpsCallable("getAgreement");
      const agreement = await getAgreement({ docid });
      const data = agreement.data || {};
      const fileURI = data.fileURI;
      this.openNewTab(fileURI);
    } catch (error) {
      this.setState({ agreementLoading: false });
      console.log(error);
      this.props.addFlag({
        appearance: 2,
        title: "Error - Please Try Again"
      });
    }
  };

  getEmployment = () => this.openNewTab(this.state.user.employmentLetter);
  getCredit = () => this.openNewTab(this.state.user.creditReport);

  openNewTab = url => window.location.assign(url);

  render() {
    const user = this.state.user || {};
    return (
      <UserContext.Consumer>
        {userContext => (
          <div className="application">
            <Helmet>
              <title>{`Application | ${user.displayName}`}</title>
            </Helmet>
            {userContext.userLoading ||
              (!userContext.userLoading &&
                userContext.user &&
                this.state.loading)}
            {this.state.loading && <Loading />}
            {!userContext.userLoading &&
              !userContext.user && <LoggedOutContent />}
            {!userContext.userLoading &&
              userContext.user &&
              !this.state.loading &&
              !!Object.keys(user).length && (
                <div className="application__applicant">
                  <div className="application__profile-card-container">
                    <ProfilePreviewCard
                      actions={[
                        {
                          label: "Agreement",
                          id: "Agreement",
                          callback: () => this.getAgreement()
                        },
                        {
                          label: "Employment",
                          id: "Employment",
                          callback: () => this.getEmployment()
                        },
                        {
                          label: "Credit",
                          id: "Credit",
                          callback: () => this.getCredit()
                        }
                      ]}
                      data={user}
                    />
                  </div>
                  <div className="application__user-attrs">
                    {Object.keys(user)
                      .filter(item => Object.keys(RequiredProfile)[item] !== -1)
                      .map(item => user[item])
                      .map((item, i) => (
                        <Panel
                          className="application__attr"
                          key={i}
                          header={<span>{Object.keys(user)[i]}</span>}
                        >
                          <div className="application__attr-content">
                            {JSON.stringify(item)}
                          </div>
                        </Panel>
                      ))}
                  </div>
                </div>
              )}
          </div>
        )}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/application/Application.js